// The four ways a quality engineer spends their effort. Weights mirror the
// composite score in the champions API so the mix reconciles with the leaderboard.
// Ported from quality-live-portal/src/components/insights/pulse/focusMix.ts (QA-2286).

export const FOCUS_AREAS = [
    {
        key: 'detection',
        label: 'Detection',
        emoji: '🐛',
        color: '#EF4444',
        desc: 'Finding defects — bugs filed',
    },
    {
        key: 'automation',
        label: 'Automation',
        emoji: '🤖',
        color: '#3B82F6',
        desc: 'Building automation — stories automated, @aiCompleted tests, e2e commits',
    },
    {
        key: 'resolution',
        label: 'Resolution',
        emoji: '✅',
        color: '#10B981',
        desc: 'Closing work — bugs closed, QA stories closed, tickets moved to done',
    },
    {
        key: 'tooling',
        label: 'Tooling',
        emoji: '🛠️',
        color: '#F59E0B',
        desc: 'QA tooling & infra — merged MRs and non-e2e repo commits',
    },
]

export const AREA_BY_KEY = Object.fromEntries(FOCUS_AREAS.map((a) => [a.key, a]))

export function focusMix(m) {
    const e2eCommits = m.commitsByRepo?.e2e ?? 0
    const toolingCommits = Math.max(0, (m.totalCommits ?? 0) - e2eCommits)
    return {
        detection: m.bugsCreated * 2,
        automation: m.storiesAutomated * 4 + m.aiCompletedTests * 2 + e2eCommits * 1,
        resolution: m.bugsClosed * 3 + m.qaStoriesClosed * 5 + (m.closerCount ?? 0) * 1,
        tooling: m.mergeRequests * 3 + toolingCommits * 2,
    }
}
